<template>
  <div class="container p-2" v-if="tes_id != '' && DateStep.Step1 != ''">
    <div class="alert alert-primary text-center" role="alert">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="width: 10%"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          10%
        </div>
      </div>
      <h3 class="p-3">ขั้นตอนที่ 1</h3>
      ระบุข้อมูลทั่วไปของผู้สมัคร...
    </div>
    <div class="alert alert-secondary">
      <div class="col-12 my-4 text-center">
        <h1><b>ข้อมูลทั่วไป</b></h1>
        <h2 class="text-danger">
          รับสมัครปีการศึกษา {{ getDataFrom2.select_year }}
        </h2>
        <h6 class="text-danger">
          กรุณากรอกข้อมูลให้ครบทั้งหมด การสมัครเรียนแบ่งออกเป็น 5 ส่วน <br />
          <b>
            หากกรอกข้อมูลไม่ครบส่วนใดส่วนหนึ่ง
            จะถือว่าการสมัครเรียนหรือจองที่เรียนไม่สมบูรณ์</b
          ><br />
          หากไม่มีข้อมูลให้ใส่เครื่องหมาย<br />
          พบปัญหาเกี่ยวกับการกรอกข้อมูลติดต่อ 053-213061 ต่อ 112
        </h6>
      </div>
      <!-- Test information -->
      <form @submit.prevent="SetStepStatus(3)">
        <fieldset class="rounded-4 border border-primary p-3 mb-5">
          <legend class="float-none w-auto px-3 fw-bold">
            <h3 class="text-primary"><b> ข้อมูลทั่วไป</b></h3>
          </legend>
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-2 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        คำนำหน้า
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      name="pre_id"
                      id="pre_id"
                      v-model="getDataFrom2.pre_id"
                      required
                    >
                      <option value="" disabled selected>-</option>
                      <option
                        v-for="item in filterPrename"
                        :key="item.pre_id"
                        :value="`${item.pre_id}`"
                      >
                        {{ item.pre_prename }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-8 my-3"></div>
                </div>
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ชื่อ
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="ชื่อ(ภาษาไทย)"
                      name="stu_fname"
                      id="stu_fname"
                      maxlength="30"
                      v-model="getDataFrom2.stu_fname"
                      required
                    />
                  </div>
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        นามสกุล
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="นามสกุล(ภาษาไทย)"
                      name="stu_lname"
                      id="stu_lname"
                      maxlength="30"
                      v-model="getDataFrom2.stu_lname"
                      required
                    />
                  </div>
                </div>
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ชื่อเล่น
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="ชื่อเล่น"
                      name="stu_nicname"
                      id="stu_nicname"
                      maxlength="25"
                      v-model="getDataFrom2.stu_nicname"
                      required
                    />
                  </div>
                  <div class="col-lg-5 my-3"></div>
                </div>
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ชื่อภาษาอังกฤษ
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="ชื่อ(ภาษาอังกฤษ)"
                      name="stu_fname_en"
                      id="stu_fname_en"
                      maxlength="100"
                      v-model="getDataFrom2.stu_fname_en"
                      required
                    />
                  </div>

                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        นามสกุลภาษาอังกฤษ
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="นามสกุล(ภาษาอังกฤษ)"
                      name="stu_lname_en"
                      id="stu_lname_en"
                      maxlength="100"
                      v-model="getDataFrom2.stu_lname_en"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- <div>
                <b-form-input list="my-list-id"></b-form-input>

                <datalist id="my-list-id">
                  <option>Manual Option</option>
                  <option
                    v-for="item in filteredStates.slice(0, 10)"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </datalist>
              </div> -->
              <div class="col-lg-12">
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        สถานศึกษาเดิม ** หมายเหตุ : หากค้นหาไม่เจอให้ระบุเป็น -
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <div class="row">
                      <div class="col-lg-4">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          name="pre_id"
                          id="pre_id"
                          v-model="getDataFrom2.provinceSearch"
                          @change="setSchoolByProvince"
                          required
                        >
                          <option value="" disabled selected>-</option>
                          <option
                            v-for="item in getDataProvince"
                            :key="item.pro_name.trim()"
                            :value="item.pro_name.trim()"
                          >
                            {{ item.pro_name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-8 mt-2 mt-lg-0">
                        <input
                          class="form-control"
                          type="text"
                          v-model="scrathSchool"
                          @input="filterStates"
                          @focus="modal = true"
                          @change="nameSchool()"
                          required
                        />
                        <div
                          v-if="scrathSchool != '' && filterStates && modal"
                          class="card"
                        >
                          <ul
                            class="list-group list-group-flush z-10 position-absolute"
                            style="width: 100%"
                          >
                            <li
                              @click="setState(item)"
                              class="d-flex justify-content-start list-group-item"
                              v-for="item in filteredStates.slice(0, 10)"
                              :key="item"
                              role="button"
                            >
                              <span>{{ item }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ระดับการศึกษา
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      name="edl_id"
                      id="edl_id"
                      v-model="getDataFrom2.edl_id"
                      @change="changeFunc(), planAll()"
                      required
                    >
                      <option
                        v-for="item in filterEducateLevel"
                        :key="item.edl_id"
                        :value="`${item.edl_id.trim()}`"
                      >
                        {{ item.edl_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        วุฒิการศึกษา
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      name="edu_id"
                      id="edu_id"
                      v-model="getDataFrom2.edu_id"
                      required
                    >
                      <option
                        v-for="item in filterEducat"
                        :key="item.edu_id"
                        :value="`${item.edu_id}`"
                      >
                        {{ item.edu_name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-lg-5 my-3"
                    v-if="getDataFrom2.edl_id != 3 && getDataFrom2.edl_id != 4"
                  >
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        สาขาที่จบ
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      v-model="allSubDepartMentStu"
                      required
                    >
                      <option value="" disabled selected>-</option>
                      <option
                        v-for="item in DataAllSubDepartment"
                        :key="item.sdep_id"
                        :value="item.sdep_id"
                      >
                        {{ item.sdep_name_ptl }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="getDataFrom2.edl_id != 5"
                    v-show="getDataFrom2.edl_id != 5"
                    class="col-lg-5 my-3"
                  ></div>
                </div>
                <div class="row form-group d-flex justify-content-center">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ต้องการศึกษาต่อในระดับ
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      v-model="getDataFrom2.cla_id"
                      required
                    >
                      <template v-if="getDataFrom2.edl_id == 3">
                        <option
                          v-for="item in filterClass1"
                          :key="item.cla_id"
                          :value="'01'"
                          selected
                        >
                          {{ item.cla_name }}
                        </option></template
                      >
                      <template v-else>
                        <option
                          v-for="item in filterClass2"
                          :key="item.cla_id"
                          :value="item.cla_id"
                          selected
                        >
                          {{ item.cla_name }}
                        </option></template
                      >
                    </select>
                    <div
                      v-if="DataCheckVer"
                      selected
                      class="col-lg-6 my-3 bg-info"
                    >
                      <h5
                        class="badge badge-info text-center my-2"
                        style="font-size: 20px"
                      >
                        แผนการเรียน: {{ DataCheckVer.ver_name }} แผน
                        {{ DataCheckVer.ver_description }}
                      </h5>
                    </div>
                  </div>
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        สาขาที่ต้องการศึกษา
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      v-model="allDepartMentStu"
                      @change="planAll()"
                      required
                    >
                      <option
                        v-for="item in DataDepRegis"
                        :key="item.sdep_id_all"
                        :value="item.sdep_id_all"
                      >
                        {{ item.sdep_name_ptl }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row form-group d-flex justify-content-center mb-5">
                  <div class="col-lg-5 my-3">
                    <h6 class="text-left" style="font-weight: bold">
                      <div class="d-flex">
                        ประเภทการสมัคร
                        <!-- {{ DataBorrowStu }} -->
                        <p style="color: red">*</p>
                      </div>
                    </h6>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      name="cap_id"
                      id="cap_id"
                      v-model="getDataFrom2.cap_id"
                      required
                    >
                      <option value="-" disabled selected>-</option>
                      <!-- <option value="-" selected>-</option> -->
                      <option
                        v-for="item in filterDataBorrowStu"
                        :key="item.bt_id"
                        :value="item.bt_id + '|' + item.bn_id"
                      >
                        {{ item.bn_name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-5 my-3"></div>
                </div>
              </div>
            </div>
            <!-- {{ this.DataCheckVer }} -->
            <div class="text-center">
              <h5 class="text-danger pb-4 fw-bold">
                กรุณาเข้ากลุ่มไลน์เพื่อรับข้อมูลข่าวสารจากทางวิทยาลัย
              </h5>
              <img
                :src="qrcodeImage"
                class="rounded col-sm-3 col-5"
                alt="..."
              />
            </div>
            <div
              v-if="
                this.getDataFrom2.link_line_group == '' ||
                this.getDataFrom2.link_line_group == null
              "
              class="text-center mt-3"
            ></div>
            <div v-else class="text-center mt-3">
              <button
                type="button"
                @click="goToLineGroup"
                class="btn btn-success"
              >
                เข้าร่วมกลุ่ม LINE
              </button>
            </div>
          </div>
          <!-- {{ this.getDataFrom2 }} -->
          <!-- {{ DataCheckVer }} -->
          <!-- {{ allDepartMentStu }} -->
        </fieldset>
        <!-- Botton Back And Next to step -->
        <div class="form-group">
          <div class="row">
            <div
              class="col"
              v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
            >
              <div class="d-inline-flex p-2" style="float: left">
                <button
                  type="button"
                  class="btn btn-primary text-white"
                  v-on:click="SetStepStatus(1)"
                >
                  <font-awesome-icon :icon="['fas', 'backward']" /> ย้อนกลับ
                </button>
              </div>
              <div class="d-inline-flex p-2" style="float: right">
                <button type="submit" class="btn btn-primary">
                  ถัดไป <font-awesome-icon :icon="['fas', 'forward']" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- v-on:click="SetStepStatus(3).prevent" -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import $ from "jquery";
export default {
  data() {
    return {
      selectedItem: null,
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      modal: false,
      allDepartMentStu: "",
      allSubDepartMentStu: "",
      query: "",
      scrathSchool: "",
      compareSchool: "",
      allSchool: [],
      allSchooltest1: ["asdasdd", "asdasasd"],
      allSchooltest2: { test: "aaaaaa" },
      filteredStates: [],
      qrcodeImage: "",
    };
  },
  async mounted() {
    // $(document).ready(function () {
    //   $(".IsText").keydown(function (e) {
    //     // Allow: backspace, delete, tab, escape, enter and .
    //     if (
    //       $.inArray(e.keyCode, [8, 9, 27, 13, 32]) !== -1 ||
    //       // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    //       ((e.ctrlKey || e.metaKey) &&
    //         $.inArray(e.keyCode, [65, 67, 88]) !== -1) ||
    //       // Allow: home, end, left, right
    //       (e.keyCode >= 35 && e.keyCode <= 39)
    //     ) {
    //       return;
    //     }

    //     if (e.ctrlKey && e.keyCode == 86) {
    //       e.preventDefault();
    //       return;
    //     }

    //     let key = e.key;

    //     // อนุญาตปุ่มพิเศษ เช่น Backspace, Delete, Tab, Enter, ลูกศร ซ้ายขวา
    //     if (
    //       [
    //         "Backspace",
    //         "Delete",
    //         "Tab",
    //         "Enter",
    //         "ArrowLeft",
    //         "ArrowRight",
    //         " ",
    //       ].includes(key)
    //     ) {
    //       return;
    //     }

    //     // ตรวจสอบว่าเป็นอักขระภาษาไทย (Unicode: U+0E00 - U+0E7F)
    //     if (!/^[\u0E00-\u0E7F]$/.test(key)) {
    //       e.preventDefault();
    //     }
    //   });
    // });

    const timestamp = new Date().getTime();
    this.qrcodeImage = `${window.qrcode}qrcode_line${this.getDataFrom2.select_year}.jpg?${timestamp}`;
    if (this.tes_id != "" && this.DateStep.Step1 != "") {
      // get Data Step2
    } else {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาดำเนินการขั้นตอน Login ก่อน...",
      });
      this.$store.dispatch("Main/SetStepStatus", 1);
      return;
    }

    await this.$store.dispatch("Main/SET_Onload", true);
    await this.$store.dispatch("Step2/SetStep2");
    if (this.getDataFrom2.stu_old_school_name != "") {
      await this.$store.dispatch("Step2/POST_OldSchoolStudent");
      this.getDataFrom2.provinceSearch = this.getDataOldSchool.sch_th_province;
    }
    await this.$store.dispatch("Step2/POST_Schoolinthailand");
    await this.$store.dispatch("Step2/GET_DataProvince");
    this.$store.dispatch("Step2/POST_SignupDateOpen");
    this.$store.dispatch("Step2/GET_DataPrename");
    this.$store.dispatch("Step2/GET_DataEducateLevel");
    this.$store.dispatch("Step2/GET_DataEducate");
    this.$store.dispatch("Step2/GET_DataClass");
    this.$store.dispatch("Step2/GET_DataDepartmentStu");
    this.$store.dispatch("Step2/GET_DataBorrowStu");
    this.$store.dispatch("Step2/GET_DataSubDepartmentStu");
    this.$store.dispatch("Step2/GET_DataAllSubDepartment");
    this.$store.dispatch("Step2/GET_DataSignupPayManual");
    this.$store.dispatch("Step2/POST_DataDepRegis");
    this.$store.dispatch("Step2/POST_DatacheckVer");

    // this.scrollToTop(this.SetStep2);

    this.getDataFrom2.stu_old_All_sdep_id = "0|0|0|0";
    // this.allSchool = this.getDataschoolinthailand;

    this.scrathSchool = this.getDataFrom2.stu_old_school;
    this.getDataFrom2.ver_id = this.DataCheckVer.ver_value;

    this.allDepartMentStuarray = [
      this.getDataFrom2.cla_id,
      this.getDataFrom2.fac_id,
      this.getDataFrom2.dep_id,
      this.getDataFrom2.sdep_id,
      this.getDataFrom2.sec_room,
      this.getDataFrom2.sec_group,
    ];
    this.allsubDepartMentStuarray = [
      this.getDataFrom2.stu_old_cla_id,
      this.getDataFrom2.stu_old_fac_id,
      this.getDataFrom2.stu_old_dep_id,
      this.getDataFrom2.stu_old_sdep_id,
    ];

    this.allDepartMentStu = this.allDepartMentStuarray.join("|");
    this.allSubDepartMentStu = this.allsubDepartMentStuarray.join("|");
    // this.getDataFrom2.stu_old_All_sdep_id = this.allDepartMentStu;
    this.getDataFrom2.stu_new_All_sdep_id = this.allSubDepartMentStu;
    // this.allDepartMentStu
    //   ? (this.getDataFrom2.stu_old_All_sdep_id = this.allDepartMentStu)
    //   : "0|0|0|0";

    var sdep_id_dep = this.allDepartMentStu.split("|");
    var cla_id = sdep_id_dep[0];
    var fac_id = sdep_id_dep[1];
    var dep_id = sdep_id_dep[2];
    var sdep_id = sdep_id_dep[3];

    cla_id = this.getDataFrom2.cla_id;
    fac_id = this.getDataFrom2.fac_id;
    dep_id = this.getDataFrom2.dep_id;
    sdep_id = this.getDataFrom2.sdep_id;

    cla_id, fac_id, dep_id, sdep_id;

    this.planAll();

    for (let value of Object.values(this.getDataschoolinthailand)) {
      this.allSchool.push(value.sch_th_name);
    }
  },
  methods: {
    planAll() {
      var sdep_all_id_sub = this.allSubDepartMentStu.split("|");
      var cla_id_sub = sdep_all_id_sub[0];
      var fac_id_sub = sdep_all_id_sub[1];
      var dep_id_sub = sdep_all_id_sub[2];
      var sdep_id_sub = sdep_all_id_sub[3];

      var sdep_all_id_dep = this.allDepartMentStu.split("|");
      var cla_id_dep = sdep_all_id_dep[0];
      var fac_id_dep = sdep_all_id_dep[1];
      var dep_id_dep = sdep_all_id_dep[2];
      var sdep_id_dep = sdep_all_id_dep[3];

      if (
        (dep_id_dep == dep_id_sub &&
          fac_id_dep == fac_id_sub &&
          sdep_id_sub == sdep_id_dep) ||
        this.getDataFrom2.edl_id == 3
      ) {
        this.getDataFrom2.planID = 1;
      } else if (
        this.getDataFrom2.stu_old_All_sdep_id == "" &&
        this.getDataFrom2.edl_id == "5"
      ) {
        this.getDataFrom2.planID = "-";
      } else if (
        dep_id_dep != dep_id_sub ||
        fac_id_dep != fac_id_sub ||
        cla_id_dep != cla_id_sub ||
        this.getDataFrom2.edl_id == 4
      ) {
        this.getDataFrom2.planID = 2;
      }
    },
    filterStates() {
      this.filteredStates = this.allSchool.filter((state) =>
        state.includes(this.scrathSchool)
      );
    },

    setState(state) {
      this.scrathSchool = state;
      this.modal = false;
      this.getDataFrom2.stu_old_school = this.scrathSchool;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เพื่อให้การเลื่อนเป็นแบบนุ่มนวล
      });
    },
    async setSchoolByProvince() {
      await this.$store.dispatch("Step2/POST_Schoolinthailand");
      this.allSchool = [];
      this.filteredStates = [];
      for (let value of Object.values(this.getDataschoolinthailand)) {
        this.allSchool.push(value.sch_th_name);
      }
    },
    async SetStepStatus(payload) {
      if (this.getDataFrom2.cap_id === "-") {
        await this.$swal({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาเลือกข้อมูลประเภทการสมัคร',
        });

        return;
      }

      if (this.getDataFrom2.stu_old_All_sdep_id) {
        var sdep_id_dep = this.getDataFrom2.stu_old_All_sdep_id.split("|");
        this.getDataFrom2.stu_old_cla_id = sdep_id_dep[0];
        this.getDataFrom2.stu_old_fac_id = sdep_id_dep[1];
        this.getDataFrom2.stu_old_dep_id = sdep_id_dep[2];
        this.getDataFrom2.stu_old_sdep_id = sdep_id_dep[3];
      }
      await this.$store.dispatch("Main/SET_Onload", true);
      this.getDataFrom2.tes_id = this.tes_id;

      for (const item of this.allSchool) {
        if (this.scrathSchool == item) {
          this.compareSchool = item;
          break;
        }
      }
      if (this.scrathSchool == this.compareSchool) {
        await this.$store.dispatch("Step2/SetStepStatus");
        if (this.DateStep2.status == true) {
          // this.$store.dispatch("Main/SetStepStatus", payload);
          await this.$swal({
            icon: this.DateStep2.type,
            title: this.DateStep2.alert,
            text: this.DateStep2.text,
          });
          this.$store.dispatch("Main/SetStepStatus", payload);
        } else if (this.DateStep2.status == false) {
          if (this.DateStep2.type == "warning") {
            await this.$swal({
              icon: this.DateStep2.type,
              title: this.DateStep2.alert,
              text: this.DateStep2.text,
            });
          } else {
            await this.$swal({
              icon: this.DateStep2.type,
              title: this.DateStep2.alert,
              html: `${this.DateStep2.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
            });
          }
        }
      } else {
        await this.$swal({
          icon: "error",
          title: "Oops...",
          text: "กรุณากรอกชื่อโรงเรียนให้ถูกต้อง",
        });
      }
    },

    async changeFunc() {
      this.getDataFrom2.stu_old_All_sdep_id = "0|0|0|0";
      this.allSubDepartMentStu = "0|0|0|0";
      this.$store.dispatch("Step2/POST_DataDepRegis");
      if (this.getDataFrom2.edl_id == 3) {
        this.getDataFrom2.cla_id = "01";
      } else {
        this.getDataFrom2.cla_id = "02";
      }
    },
    async nameSchool() {
      this.getDataFrom2.stu_old_school = this.scrathSchool;
    },
    async goToLineGroup() {
      window.open(this.getDataFrom2.link_line_group, "_blank");
    },
  },
  watch: {
    allDepartMentStu: {
      async handler() {
        var sdep_all_id_dep = this.allDepartMentStu.split("|");
        var fac_id_dep = sdep_all_id_dep[1];
        var dep_id_dep = sdep_all_id_dep[2];
        var sdep_id_dep = sdep_all_id_dep[3];
        var sec_class = "1";
        var sec_room = sdep_all_id_dep[4];
        var sec_group = sdep_all_id_dep[5];
        this.getDataFrom2.dep_id = dep_id_dep;
        this.getDataFrom2.fac_id = fac_id_dep;
        this.getDataFrom2.sdep_id = sdep_id_dep;
        this.getDataFrom2.sec_class = sec_class;
        this.getDataFrom2.sec_room = sec_room;
        this.getDataFrom2.sec_group = sec_group;
        this.getDataFrom2.stu_new_All_sdep_id = this.allDepartMentStu;
        await this.$store.dispatch("Step2/POST_DatacheckVer");
        this.getDataFrom2.ver_id = this.DataCheckVer.ver_value;
        // this.$store.dispatch("Step2/SET_checkVer");
      },
    },
    allSubDepartMentStu: {
      handler() {
        this.getDataFrom2.stu_old_All_sdep_id = this.allSubDepartMentStu;
        this.$store.dispatch("Step2/POST_DataDepRegis");
        this.$store.dispatch("Step2/POST_DatacheckVer");
      },
    },
  },
  computed: {
    filterDataschoolinthailand() {
      return this.getDataschoolinthailand.filter((item) => item.sch_th_name);
    },
    filterEducateLevel() {
      return this.DataEducateLevel.filter(
        (item) => item.edl_id >= 3 && item.edl_id <= 5
      );
    },
    filterEducat() {
      return this.DataEducate.filter(
        (item) =>
          item.edu_id === "03" &&
          item.edl_id.trim() === this.getDataFrom2.edl_id.trim()
      );
    },
    filterDepartMentStu() {
      return this.DataDepartmentStu.filter(
        (item) => item.dep_active_stat == "1" && item.cla_id == "01"
      );
    },
    filterDataBorrowStu() {
      return this.DataBorrowStu.filter(
        (item) =>
          item.cla_id.trim() == this.getDataFrom2.cla_id.trim() &&
          item.fac_id.trim() == this.getDataFrom2.fac_id.trim() &&
          item.dep_id.trim() == this.getDataFrom2.dep_id.trim() &&
          item.sdep_id.trim() == this.getDataFrom2.sdep_id.trim()
      );
    },
    filterDataSubDepartmentStu() {
      return this.DataSubDepartmentStu.filter(
        (item) => item.sdepActive == "1" && item.cla_id == "01"
      );
    },
    filterClass1() {
      return this.DataClass.filter((item) => item.cla_id === "01");
    },
    filterClass2() {
      return this.DataClass.filter((item) => item.cla_id === "02");
    },
    filterPrename() {
      return this.getDataPrename.filter((item) => item.pre_id != "NN");
    },

    ...mapGetters({
      tes_id: "Main/_getTesID",
      SetStep2: "Main/_SetStep2",
      DateStep: "Main/_getDateStep",
      DateStep2: "Main/_getDateStep2",
      getDataFrom2: "Step2/_getDataFrom2",
      getDataPrename: "Step2/_getDataprename",
      getDataschoolinthailand: "Step2/_getDataschoolinthailand",
      DataEducateLevel: "Step2/_getDataEducateLevel",
      DataEducate: "Step2/_getDataEducate",
      DataClass: "Step2/_getDataClass",
      DataDepartmentStu: "Step2/_getDataDepartmentStu",
      DataBorrowStu: "Step2/_getDataBorrowStu",
      DataSubDepartmentStu: "Step2/_getDataSubDepartmentStu",
      DataDepRegis: "Step2/_getDataDepRegis",
      DataAllSubDepartment: "Step2/_getDataAllSubDepartment",
      DataCheckVer: "Step2/_getDatacheckVer",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
      getDataProvince: "Step2/_getDataProvince",
      getDataOldSchool: "Step2/_getDataOldSchool",
    }),
  },
};
</script>

<style></style>
<style>
fieldset,
legend {
  all: revert;
}
</style>
